import { bff, toClientError } from './bff'

const run = (p) => p.then((r) => r.data).catch((e) => Promise.reject(toClientError(e)))

// All durable background work runs as control-plane sagas (imports, bulk
// transcription, indexing, code-docs, teardown). The list carries step data for
// ACTIVE sagas so the Activity view shows live progress from one poll.
export const listSagas = ({ limit = 50 } = {}) =>
  run(bff.get('/api/sagas', { params: { limit } }))

export const cancelSaga = (id) => run(bff.post(`/api/sagas/${id}/cancel`))

// Recurring pollers (feeds/follows/watches/code-sync): enabled flag + last/next
// run. Distinct from sagas — these are in-process interval jobs.
export const listPollers = () => run(bff.get('/api/pollers'))

